import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tvt-logistics-india-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
